
const getAllURL = window.REACT_APP_CONFIG?.GET_ALL_URL || process.env.GET_ALL_URL || 'https://192.168.10.13:3005/';
const apiFaceBaseURL = window.REACT_APP_CONFIG?.REACT_APP_API_FACE_BASE_URL || process.env.REACT_APP_API_FACE_BASE_URL || 'https://192.168.10.13:3005/api/face';

module.exports = {
  'secretKey1': process.env.SECRET_KEY_1 || '16665-66690-09546-23321',
  'mongoUrl1': process.env.MONGO_URL_1 || 'mongodb://localhost:27017',
  'getAllURL': getAllURL,
  'apiFaceBaseURL': apiFaceBaseURL,
  'interval': parseInt(process.env.INTERVAL, 10) || 4000
}

// module.exports = {
//   'secretKey1': '16665-66690-09546-23321',
//   'mongoUrl1' : 'mongodb://localhost:27017',
//   'getAllURL': "https://192.168.1.217:3005/",
//   'interval': 4000
// }

// module.exports = {
//   'secretKey1': '16665-66690-09546-23321',
//   'mongoUrl1' : 'mongodb://192.168.1.107:27017,192.168.1.108:27017,192.168.1.132:27017/DB4app2?replicaSet=myreplica',
//   // 'getAllURL': "http://192.168.1.246:3005/",
//   // 'getAllURL': "http://192.168.1.107:3005/",
//   'getAllURL':  "http://27.72.101.197:80/be/",
//   // "http://localhost:82/api/",
//   'interval': 4000
// }
